import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function ScheduleCheckHourSummaryHeader({ sortConfig, requestSort }) {
    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col>
                    <Row>
                        <Col onClick={requestSort ? () => requestSort("hour_from") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1 text-center">Hour</span>
                                <span className="col-1">{renderSortIcon("hour_from", sortConfig)}</span>
                            </Stack>
                        </Col>
                        <Col onClick={requestSort ? () => requestSort("removed") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1 text-center">Dropped Songs</span>
                                <span className="col-1">{renderSortIcon("removed", sortConfig)}</span>
                            </Stack>
                        </Col>
                        <Col onClick={requestSort ? () => requestSort("added") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1 text-center">Added Songs</span>
                                <span className="col-1">{renderSortIcon("added", sortConfig)}</span>
                            </Stack>
                        </Col>
                    </Row>
                </Col>
                <Col className=" d-none d-xl-block border-start">
                    <Row>
                        <Col onClick={requestSort ? () => requestSort("hour_from") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1 text-center">Hour</span>
                                <span className="col-1">{renderSortIcon("hour_from", sortConfig)}</span>
                            </Stack>
                        </Col>
                        <Col onClick={requestSort ? () => requestSort("removed") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1 text-center">Dropped Songs</span>
                                <span className="col-1">{renderSortIcon("removed", sortConfig)}</span>
                            </Stack>
                        </Col>
                        <Col onClick={requestSort ? () => requestSort("added") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1 text-center">Added Songs</span>
                                <span className="col-1">{renderSortIcon("added", sortConfig)}</span>
                            </Stack>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}
